<template>
<div class="modal-card">
  <header class="modal-card-head">
    <p class="modal-card-title">{{title}}</p>
    <slot name="controls">
      <!-- 默认关闭按钮 -->
      <button class="delete" type="button" aria-label="close" @click="close"></button>
    </slot>
  </header>
  <section class="modal-card-body">
    <slot></slot>
  </section>
  <footer class="modal-card-foot" v-if="footer">
    <slot name="footer">
      <button class="button" type="button" @click="close">
        {{$t('button-close')}}
      </button>
    </slot>
  </footer>
</div>
</template>

<script>
export default {
  name: 'cytomine-modal-card',
  props: {
    title: String,
    footer: {type: Boolean, default: true}
  },
  methods: {
    close() {
      this.$emit('close');
      if (!this.$listeners.close && this.$parent) {
        this.$parent.$emit('close');
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/dark-variables.scss';

.modal-card {
  @include clinical-modal-card;
}

.modal-card-head {
  @include clinical-modal-head;
  padding: 0.95rem 1.05rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-card-title {
  color: $dark-text-primary;
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
}

.modal-card-body {
  @include clinical-modal-body;
  padding: 1.05rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-card-foot {
  @include clinical-modal-foot;
  padding: 0.9rem 1.05rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* Delete button styles for dark theme */
.delete {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline-block;
  flex-shrink: 0;
  border-radius: 5px;
  height: 22px;
  position: relative;
  vertical-align: top;
  width: 22px;
  transition: background-color 0.16s ease;
}

.delete:hover {
  background-color: rgba($primary, 0.12);
}

.delete::before,
.delete::after {
  background-color: $dark-text-secondary;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform-origin: center center;
}

.delete::before {
  height: 2px;
  width: 50%;
}

.delete::after {
  height: 50%;
  width: 2px;
}

.delete:hover::before,
.delete:hover::after {
  background-color: $primary;
}

.delete:focus {
  outline: none;
}
</style>
